import React from 'react';
import { Link } from 'react-router-dom';
import './HeroSection.css';

function HeroSection() {
    return (
        <section className='hero-container'>

            {/* ── Image de fond ────────────────────────────────── */}
            <img
                id="background"
                src="/images/TrilogieHeroSectionImg.jpg"
                alt=""
                aria-hidden="true"
            />

            {/* ── Contenu centré ───────────────────────────────── */}
            <div className='hero-content'>

                <span className='hero-eyebrow'>Restaurant · Liège</span>

                <img
                    id="titre"
                    src="/images/Titre_transparent_blanc.png"
                    alt="Trilogie Restaurant"
                />

                <div className='hero-divider' />

                <div className='hero-btns'>
                    <Link
                        to='/menu'
                        className='hero-btn hero-btn--outline'
                    >
                        Découvrir le menu
                    </Link>
                    <Link
                        to='https://bookings.zenchef.com/results?rid=379037&pid=1001'
                        target='_blank'
                        rel='noopener noreferrer'
                        className='hero-btn hero-btn--primary'
                    >
                        Réserver <i className="fa-solid fa-arrow-up-right-from-square" />
                    </Link>
                </div>
            </div>

            {/* ── Scroll indicator ─────────────────────────────── */}
            <div className='hero-scroll' aria-hidden="true">
                <span className='hero-scroll-label'>Défiler</span>
                <div className='hero-scroll-line' />
            </div>

        </section>
    );
}

export default HeroSection;
